
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import {
  addProduction,
  updataProduction,
  getSalesOrdersList,
  getProductionDetails,
  getModelListPage
} from "@/api/api-basic";
import { optionKey, getOptionList } from "@/api/api-dict";
import regular from "@/common/regular";
import maxIntCompute from "@/common/maxIntCompute";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class ProductionOrderQualityCheck extends Vue {
  private modalTitle = i18n.t("productionOrder.content0");
  private formInline: objAny = {
    equipmentInfo: [],
    inspectionAndSignature: "",
    issuerAndCard: "",
    logisticsAndNumber: "",
    orderType: "",
    priority: "",
    projectName: "",
    projectNamePkId: "",
    remark: "",
    sellerName: "",
    shippingCardIssuerICCard: "",
    verifier: "",
    checkContent: "",
    contractBillNumber: "",
    deliveryRequirements: ""
  };
  private equipmentInfo: objAny = {
    clientNum: "",
    displayScreen: "",
    equipmentRemarks: "",
    interfaceBoard: "",
    materialNumber: "",
    modelName: "",
    deviceModelPkId: "",
    motherboard: "",
    quantity: 0,
    platformModel: 0,
    projectNamePkId: "",
    requirements: "",
    deviceStartNo: "",
    deviceEndNo: "",
    deviceType: ""
  };
  private current = 0;
  private orderList: object[] = [];
  private orderTypeList: object[] = [];
  private typeList: object[] = [];
  private contractBillNumberList: object[] = [];
  private inprojectNameList: object[] = [];
  private priorityList: object[] = [];
  private platformModelList: object[] = [];
  private modelList: object[] = [];

  private loading = false;
  private formObj: objAny = {};
  private details: objAny = {};

  private ruleInline: objAny = {
    orderType: [
      {
        required: true,
        message: i18n.t("productionOrder.orderTypePl"),
        trigger: "change"
      }
    ],
    contractBillNumber: [
      {
        required: true,
        message: i18n.t("productionOrder.contractBillNumberPl"),
        trigger: "change"
      }
    ],
    projectNamePkId: [
      {
        required: true,
        message: i18n.t("productionOrder.projectNamePl"),
        trigger: "change"
      }
    ],
    priority: [
      {
        required: true,
        message: i18n.t("productionOrder.priorityPl"),
        trigger: "change"
      }
    ],

    materialNumber: [
      {
        required: true,
        message: i18n.t("productionOrder.materialNumberPl"),
        trigger: "blur"
      }
    ],
    clientNum: [
      {
        required: true,
        message: i18n.t("productionOrder.clientNumPl"),
        trigger: "blur"
      }
    ],
    platformModel: [
      {
        required: true,
        message: i18n.t("productionOrder.platformModelPl"),
        trigger: "change"
      }
    ],
    deviceStartNo: [
      {
        required: true,
        validator: regular.int,
        trigger: "blur",
        name: i18n.t("productionOrder.deviceStartNo")
      }
    ],
    deviceEndNo: [
      {
        required: true,
        validator: regular.int,
        trigger: "blur",
        name: i18n.t("productionOrder.deviceEndNo")
      }
    ],
    motherboard: [
      {
        required: true,
        message: i18n.t("productionOrder.motherboardPl"),
        trigger: "blur"
      }
    ],
    interfaceBoard: [
      {
        required: true,
        message: i18n.t("productionOrder.interfaceBoardPl"),
        trigger: "blur"
      }
    ],
    requirements: [
      {
        required: true,
        message: i18n.t("productionOrder.requirementsPl"),
        trigger: "blur"
      }
    ],
    equipmentRemarks: [
      {
        required: true,
        message: i18n.t("productionOrder.equipmentRemarksPl"),
        trigger: "blur"
      }
    ],

    issuerAndCard: [
      {
        required: true,
        message: i18n.t("productionOrder.issuerAndCardPl"),
        trigger: "blur"
      }
    ],
    shippingCardIssuerICCard: [
      {
        required: true,
        message: i18n.t("productionOrder.shippingCardIssuerICCardPl"),
        trigger: "blur"
      }
    ],
    remark: [
      {
        required: true,
        message: i18n.t("productionOrder.remarkPl"),
        trigger: "blur"
      }
    ],
    modelName: [
      {
        required: true,
        message: i18n.t("productionOrder.deviceModelPkIdPl"),
        trigger: "blur"
      }
    ],
    deviceModelPkId: [
      {
        required: true,
        message: i18n.t("productionOrder.deviceModelPkIdPl"),
        trigger: "change"
      }
    ],
    quantity: [
      { required: true, validator: regular.int, max: 999999, trigger: "blur" }
    ],
    displayScreen: [
      {
        required: true,
        message: i18n.t("productionOrder.displayScreenPl"),
        trigger: "blur"
      }
    ]
  };
  private itemData: objAny = {};
  private modalShow = false;
  private disabled = false;
  private numberQuantity = 0;
  private pageType = "add";
  public open(item: objAny, type: string) {
    this.modalShow = true;
    if (item) {
      this.itemData = item;
    }
    this.pageType = type;
    this.resetForm();
    this.getSalesOrdersList();

    if (type != "add") {
      this.formInline.contractBillNumber = item.contractBillNumber;
      this.getProductionDetails();
    }
    this.getModelListPage();
    if (type == "add") {
      this.modalTitle = i18n.t("productionOrder.add");
      this.disabled = false;
      this.formInline.orderType = "0";
    } else if (type == "updata") {
      this.modalTitle = i18n.t("productionOrder.updata");
      this.disabled = false;
    } else {
      this.modalTitle = i18n.t("productionOrder.details");
      this.disabled = true;
    }
  }
  public resetForm() {
    console.log(JSON.parse(JSON.stringify(this.formInline)));
    for (const i in this.formInline) {
      if (typeof this.formInline[i] == "string") {
        this.formInline[i] = "";
      }
    }
    // this.handleReset();
    this.formInline.equipmentInfo = [];
    this.addDevClick();
  }
  public addDevClick() {
    const json: objAny = JSON.parse(JSON.stringify(this.equipmentInfo));
    this.formInline.equipmentInfo.push(json);
  }
  public delDevClick(index: number) {
    this.formInline.equipmentInfo.splice(index, 1);
  }
  public handleSubmit() {
    this.formObj.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  async getProductionDetails() {
    const ret = await getProductionDetails({
      contractBillNumber: this.formInline.contractBillNumber
    });
    if (ret.status === this.$config.apiStatus) {
      const data = ret.data[0];
      for (const i in data) {
        if (this.formInline[i] != undefined) {
          if (data[i] == null) {
            this.formInline[i] = "";
          } else {
            this.formInline[i] = data[i];
          }
        }
      }
      this.details = data;
      this.formInline.priority += "";
      this.formInline.orderType += "";
      this.formInline.equipmentInfo.map((item: objAny) => {
        item.platformModel += "";
        if (!item.deviceEndNo) {
          item.deviceEndNo = "";
        }
        if (!item.deviceStartNo) {
          item.deviceStartNo = "";
        }
      });
      if (data.productionStatus) {
        this.current = data.productionStatus >= 4 ? 4 : data.productionStatus;
      }
    }
  }
  async submitData(): Promise<void> {
    let ret;
    this.loading = true;
    if (this.pageType == "add") {
      ret = await addProduction(this.formInline);
    } else {
      ret = await updataProduction(this.formInline);
    }
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.$emit("success");
      this.modalShow = false;
    }
    this.loading = false;
  }
  public handleReset() {
    this.formObj.resetFields();
  }
  async getOptionList() {
    const data = await getOptionList([
      optionKey.orderType,
      optionKey.platformModel,
      optionKey.priority
    ]);
    this.orderTypeList = data[optionKey.orderType];
    this.platformModelList = data[optionKey.platformModel];
    this.priorityList = data[optionKey.priority];
  }
  async getSalesOrdersList() {
    const ret = await getSalesOrdersList({
      globalPageIndex: 1,
      globalPageSize: 100,
      globalSearch: ""
    });
    if (ret.status === this.$config.apiStatus) {
      this.contractBillNumberList = ret.data;
    }
  }
  public contractBillNumberChange(val: string) {
    this.contractBillNumberList.map((item: objAny) => {
      if (item.contractBillNumber == val) {
        this.formInline.projectName = item.projectName;
        this.formInline.projectNamePkId = item.projectNamePkId;
      }
    });
  }
  public loseFocus(unit: objAny) {
    if (unit.deviceEndNo && unit.deviceStartNo) {
      this.numberQuantity = parseFloat(
        maxIntCompute(unit.deviceEndNo, unit.deviceStartNo)
      );
      unit.quantity = this.numberQuantity + 1;
    } else {
      unit.quantity = "";
    }
  }
  async getModelListPage() {
    const ret = await getModelListPage({
      globalPageIndex: 1,
      globalPageSize: 100
    });
    if (ret.status === this.$config.apiStatus) {
      this.modelList = ret.data;
    }
  }
  public deviceModelChange(index: number, value: string) {
    this.modelList.map((item: objAny) => {
      if (item.deviceModelPkId == value) {
        this.formInline.equipmentInfo[index].deviceType = item.deviceType;
      }
    });
  }
  mounted() {
    this.getOptionList();

    this.$nextTick(() => {
      this.formObj = this.$refs["formValidate"];
    });
  }
}
